<auth-layout titulo="Atualize sua senha" subtitulo="Crie uma nova senha para voltar ao painel.">
  <reset-password-form />
</auth-layout>
